import RiskTypeSelection from "src/components/RiskTypeSingleSelection";
import { useTranslation } from "src/hooks";
import { useBatchContractSweepFormContext } from "../../../contexts";

function RiskTypeSingleSelection() {
  const {
    fields,
    setFields,
    translate: t,
  } = useBatchContractSweepFormContext();
  const { tc } = useTranslation("common");

  const label = t("risk_type");

  return (
    <>
      <div>{label}</div>
      <RiskTypeSelection
        value={fields.riskType}
        label={tc("phSelection", { fieldName: label })}
        onChange={(e) =>
          setFields((prev) => ({
            ...prev,
            riskType: e.target.value,
          }))
        }
        onClearSelect={() => {}}
      />
    </>
  );
}

export default RiskTypeSingleSelection;
